<template>
  <div>
    <Return :value="is_all_true" />
    <div class="bodyControll">
      <div class="steps">
        <Step :step="2" />
      </div>
      <div class="them" style="margin-top: 28px">
        <div>
          <div class="line"></div>
          新增年度业绩信息
        </div>
        <div class="textBox">
          <span class="gray">近三年业绩信息 / {{ year }}年度业绩信息 / </span>
          <span class="gray black">&nbsp;新增年度业绩信息</span>
        </div>
      </div>
      <div class="importBtn" @click="dialogVisible = true">导入业绩</div>
      <el-table
        ref="table"
        class="tableContrpll"
        :data="tableData"
        @row-click="row_click"
        style="width: 100%"
        max-height="500"
        v-loading="loading"
        element-loading-text="处理中，可能会比较耗时，请等待..."
      >
        <el-table-column fixed label="项目名称" width="250">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.name"
              placeholder="请输入项目名称"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="项目类型" width="220">
          <template slot-scope="scope">
            <el-form>
              <el-form-item>
                <el-input
                  v-model="scope.row.type"
                  placeholder="请输入项目类型"
                ></el-input>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column label="项目起止日期" width="380">
          <template slot-scope="scope">
            <el-form>
              <el-form-item>
                <el-date-picker
                  v-model="scope.row.skk_time"
                  @change="
                    (val) => {
                      changeTime(val, scope.row, scope.$index);
                    }
                  "
                  type="daterange"
                  format="yyyy 年 MM 月 dd 日"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                />
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column label="委托单位名称" width="250">
          <template slot-scope="scope">
            <el-form>
              <el-form-item>
                <el-input
                  v-model="scope.row.company"
                  placeholder="请输入委托单位名称"
                ></el-input>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="承接业务专业" width="300">
          <template slot-scope="scope">
            <el-form>
              <el-cascader
                @change="
                  (val) => {
                    handleChange(val, scope.row, scope.$index);
                  }
                "
                v-model="scope.row.service"
                :options="options"
                :props="{ expandTrigger: 'hover' }"
              ></el-cascader>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column label="项目造价/投资金额（万）" width="270">
          <template slot-scope="scope">
            <el-form>
              <el-form-item>
                <el-input
                  v-model="scope.row.amount"
                  placeholder="请输入项目造价/投资金额（万）"
                ></el-input>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column label="收费比例" width="200">
          <template slot-scope="scope">
            <el-form>
              <el-form-item>
                <el-input
                  v-model="scope.row.ratio"
                  placeholder="请输入收费比例"
                ></el-input>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column label="收费金额（万）" width="220">
          <template slot-scope="scope">
            <el-form>
              <el-form-item>
                <el-input
                  v-model="scope.row.money"
                  placeholder="请输入收费金额（万）"
                ></el-input>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column label="收费时间" width="260">
          <template slot-scope="scope">
            <el-form>
              <el-form-item prop="money_time">
                <el-date-picker
                  v-model="scope.row.money_time"
                  type="date"
                  format="yyyy 年 MM 月 dd 日"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column label="发票号码" width="270">
          <template slot-scope="scope">
            <el-form>
              <el-form-item>
                <el-input
                  v-model="scope.row.bill_code"
                  placeholder="请输入发票号码"
                ></el-input>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column label="项目负责人" width="200">
          <template slot-scope="scope">
            <el-form>
              <el-form-item>
                <el-input
                  v-model="scope.row.technical_name"
                  placeholder="请输入项目负责人"
                ></el-input>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column label="项目负责人联系电话" width="250">
          <template slot-scope="scope">
            <el-form>
              <el-form-item>
                <el-input
                  v-model="scope.row.technical_tel"
                  placeholder="请输入项目负责人联系电话"
                ></el-input>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="70">
          <template slot-scope="scope">
            <el-form>
              <el-popconfirm
                title="确定删除这条业绩吗？"
                @confirm="
                  () => {
                    handlerDelete(scope.$index);
                  }
                "
              >
                <el-button
                  type="text"
                  slot="reference"
                  size="small"
                  class="del"
                >
                  删除
                </el-button>
              </el-popconfirm>
            </el-form>
          </template>
        </el-table-column>
      </el-table>

      <div class="btnControll">
        <div @click="add()" class="save blue">继续增加</div>
        <div @click="save()" class="save">保存</div>
      </div>
      <!--            导入业绩弹窗-->
      <el-dialog
        v-if="dialogVisible"
        title="导入年度业绩信息"
        width="540px"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
      >
        <span class="tipNumber">注：一次性最多导入300条业绩</span>
        <span class="tex"
          ><span class="r">上传文件</span
          ><span class="red">*只能上传xlsx、xls表格格式文件</span></span
        >
        <Upload
          class="upStyle"
          :filesExcel.sync="excel"
          :excel="true"
          :hasUploadExcel.sync="hasUploadExcel"
        ></Upload>
        <div style="margin-top: 10px">
          <a
            class="linkExcel"
            :href="$api_imageUrl + '/upload/project.xlsx?v=91'"
            target="_blank"
            >下载导入excel模板文件</a
          >
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirmBtn()">确认添加</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { get_options } from "@/components/record/options.js"; //业务类型
import Return from "@/components/record/Return";
import Step from "@/components/record/Step";
// import { createPer } from "@/api/yj";
import { createEach } from "@/api/yj";
// import { getUploadYj } from "@/api/common";
import Upload from "@/components/record/Upload";
import { Loading } from "element-ui";
import { getUploadYj } from "@/api/common";

export default {
  name: "yjAdd.vue",
  components: {
    Return,
    Step,
    Upload,
  },
  created() {
    if (this.$route.query.record_id) {
      this.record_id = Number(this.$route.query.record_id);
    }
    if (this.$route.query.year) {
      this.year = Number(this.$route.query.year);
    }
    this.init();
  },
  data() {
    return {
      hasUploadExcel: false, //是否上传了excel文件
      isFirst: true,
      is_jiazai: false,
      delIndex: [], //要删除的数组索引
      newDelIndex: [], //去重的数组索引
      dialogVisible: false, //导入业绩弹窗
      excel: [], //上传的excel文件
      excelShengyu: [], //excel网页中未滚动加载到的数据
      loading: false,
      skk_data: {
        name: "",
      },
      record_id: null,
      year: null,
      tableData: [
        {
          name: "",
          type: "",
          company: "",
          start_time: "",
          finish_time: "",
          service1: "",
          service2: "",
          service3: "",
          amount: "",
          ratio: "",
          money: "",
          money_time: "",
          bill_code: "",
          technical_name: "",
          technical_tel: "",
        },
      ],
      dom: null,
      errData: [],
      is_all_true: true,
      options: [],
      page: 1,
      limit: 10,
      has_data: true, //滚动的时候 是否还有数据需要加载 默认有
      current_row: {}, //当前编辑的行
      loadData: null,
    };
  },
  mounted() {
    // 获取需要绑定的table
    this.dom = this.$refs.table.bodyWrapper;
    this.dom.addEventListener("scroll", () => {
      // 滚动距离
      let scrollTop = this.dom.scrollTop;
      // console.log(scrollTop, "scrollTop--滚动距离");
      // 变量windowHeight是可视区的高度
      let windowHeight = this.dom.clientHeight || this.dom.clientHeight;
      // console.log(windowHeight, "windowHeight--可视区的高度");
      // 变量scrollHeight是滚动条的总高度
      let scrollHeight = this.dom.scrollHeight || this.dom.scrollHeight;
      // console.log(scrollHeight, "scrollHeight--滚动条的总高度");
      if (scrollTop + windowHeight >= scrollHeight - 10) {
        // 获取到的不是全部数据 当滚动到底部 继续获取新的数据
        // console.log(this.has_data, "this.has_data");
        if (this.has_data) {
          console.log("---if");
          this.getMoreLog();
        }
      }
    });
  },
  methods: {
    //处理excel网页中还未加载的数据
    async chuli_excelSheng() {
      console.log(this.page, "shengyu----- page");
      console.log(this.page, "当前加载了几页");
      if (!this.isFirst) {
        this.page += 1;
      }
      this.isFirst = false;
      const res = await getUploadYj({
        page: this.page,
        limit: this.limit,
      });
      //时间和三级联动处理
      if (res && res.list.length > 0) {
        this.excelShengyu = res.list;
        for (let i in this.excelShengyu) {
          let temObj1 = this.excelShengyu[i];
          if (temObj1.finish_time || temObj1.start_time) {
            let a = temObj1.finish_time;
            a.substring(0, 9);
            let b = temObj1.start_time;
            b.substring(0, 9);
            temObj1.start_time = b;
            temObj1.finish_time = a;
          }
          temObj1.skk_time = [temObj1.start_time, temObj1.finish_time];

          if (temObj1.service3 && temObj1.service2 && temObj1.service1) {
            temObj1.service = [
              temObj1.service1,
              temObj1.service2,
              temObj1.service3,
            ];
          }
          if (!temObj1.service3 && temObj1.service2 && temObj1.service1) {
            temObj1.service = [temObj1.service1, temObj1.service2];
          }
          // 把十条temObj1逐条传给后台保存
          // let is_success1 = true; //当前条是否保存成功
          try {
            //打开菊花
            // this.loading = true;
            //逐条新增
            const res = await createEach({
              project: JSON.stringify(temObj1),
              year: this.year,
              record_id: this.record_id,
            });
            //为9，excel过来的这条报错了
            if (res.result && res.result == 9) {
              // this.$message.error(`表格中剩余部分未保存成功，项目填写出错！`);
              this.is_all_true = false;
              // is_success1 = false; //当前条是否保存成功
            }

            //如果保存的有错误，code还是为1，判断里面得字段
          } catch (e) {
            this.is_all_true = false;
            // is_success = false; //当前条是否保存成功
            // console.log(e, "错误了");
          }
        }
      } else {
        //没有数据了
        this.has_data = false;
        console.log("没数据了");
      }
    },
    async getMoreLog() {
      // console.log("--------->>>");
      //渲染组件里面拿到的excel数据
      this.loadData = Loading.service({
        lock: true,
        text: "数据加载中...",
        background: "rgba(0, 0, 0, 0.7)",
      });
      console.log("开始请求" + this.page);

      //先请求获取第一页的数据
      if (this.is_jiazai) {
        return false;
      }
      this.is_jiazai = true;
      const res = await getUploadYj({ page: this.page, limit: this.limit });
      this.$nextTick(() => {
        // 以服务的方式调用的 Loading 需要异步关闭
        this.loadData.close();
      });
      // console.log(this.loadData);
      // console.log("请求结束" + this.page);
      if (res && res.list.length > 0) {
        this.excel = res.list;
        //时间和三级联动处理
        this.chuli();
        this.dom.scrollTop = this.dom.scrollTop - 100;
        // console.log("处理结束" + this.page);
        this.page += 1; //
        this.is_jiazai = false;
      } else {
        //没有数据了
        this.has_data = false;
        console.log("没数据了");
      }
      this.is_jiazai = false;
    },
    chuli() {
      for (let i in this.excel) {
        //this.excel[i] /{xx:xx,xx:xx}

        let temObj = this.excel[i];
        if (temObj.finish_time || temObj.start_time) {
          let a = temObj.finish_time;
          a.substring(0, 9);
          let b = temObj.start_time;
          b.substring(0, 9);
          temObj.start_time = b;
          temObj.finish_time = a;
        }
        temObj.skk_time = [temObj.start_time, temObj.finish_time];

        if (temObj.service3 && temObj.service2 && temObj.service1) {
          temObj.service = [temObj.service1, temObj.service2, temObj.service3];
        }
        if (!temObj.service3 && temObj.service2 && temObj.service1) {
          temObj.service = [temObj.service1, temObj.service2];
        }

        this.tableData.push(temObj);
      }
    },
    //点击弹窗里面的确认添加
    async confirmBtn() {
      console.log(this.hasUploadExcel, "this.hasUploadExcel");
      if (!this.hasUploadExcel) {
        this.$message.error("请上传文件后添加！");
        return false;
      } else {
        //加载菊花
        console.log(this.hasUploadExcel, "-------this.hasUploadExcel");
        let loadingInstance = Loading.service({
          lock: true,
          text: "处理中，导入可能会比较耗时，请等待...",
          background: "rgba(0, 0, 0, 0.7)",
        });

        //传过文件，先渲染,请求获取第一页的数据
        const res = await getUploadYj({ page: this.page, limit: this.limit });
        this.page += 1;
        console.log(res, "获取第一页的res");
        this.excel = res.list;
        //时间和三级联动处理
        this.chuli();

        //把数组里面空白的行去掉，一进来的时候网页版excel也有个空的行，设计图要求
        this.tableData.forEach((it, index) => {
          let c = true;
          for (let k in it) {
            if (it[k]) {
              c = false;
              break;
            }
          }
          if (c) {
            this.delIndex.push(index);
          }
        });
        //要删除数组里面的这个索引
        this.delIndex.reverse();
        this.delIndex.forEach((i) => {
          this.tableData.splice(i, 1);
        });

        // 以服务的方式调用的 Loading 需要异步关闭
        setTimeout(() => {
          loadingInstance.close();
        }, 3000);

        this.dialogVisible = false;
      }
    },
    // 初始化表格中的数据
    init() {
      this.options = get_options();
      // console.log(this.options, "this.options");
      // for (let i = 0; i < 150; i++) {
      //   // this.tableData.push([
      //   //   {
      //   //     name: "555",
      //   //     type: "",
      //   //     company: "",
      //   //     start_time: "",
      //   //     finish_time: "",
      //   //     service1: "",
      //   //     service2: "",
      //   //     service3: "",
      //   //     amount: "",
      //   //     ratio: "",
      //   //     money: "",
      //   //     money_time: "",
      //   //     bill_code: "",
      //   //     technical_name: "",
      //   //     technical_tel: "",
      //   //   },
      //   // ]);
      //   this.$set(this.tableData, i, {
      //     name: "555",
      //     type: "",
      //     company: "",
      //     start_time: "",
      //     finish_time: "",
      //     service1: "",
      //     service2: "",
      //     service3: "",
      //     amount: "",
      //     ratio: "",
      //     money: "",
      //     money_time: "",
      //     bill_code: "",
      //     technical_name: "",
      //     technical_tel: "",
      //   });
      // }
    },
    row_click(row) {
      this.current_row = row;
    },
    handleChange(value, row, index) {
      if (value) {
        row.service1 = value[0];
        row.service2 = value[1];
        if (value.length == 3) {
          row.service3 = value[value.length - 1];
        }
        this.$set(this.tableData, index, row);
      }
    },
    // 删除
    handlerDelete(ind) {
      this.tableData.splice(ind, 1);
    },
    changeTime(times, row, index) {
      row.start_time = times[0];
      row.finish_time = times[1];
      this.$set(this.tableData, index, row);
    },
    //继续增加
    add() {
      this.tableData.push({
        name: "",
        type: "",
        company: "",
        start_time: "",
        finish_time: "",
        service1: "",
        service2: "",
        service3: "",
        amount: "",
        ratio: "",
        money: "",
        money_time: "",
        bill_code: "",
        technical_name: "",
        technical_tel: "",
      });
    },
    //保存
    async save() {
      this.is_all_true = true; //是否都保存成功了
      //处理excel表格中的数据
      for (let item of this.tableData) {
        let is_success = true; //当前条是否保存成功
        try {
          //打开菊花
          this.loading = true;
          //逐条新增
          const res = await createEach({
            project: JSON.stringify(item),
            year: this.year,
            record_id: this.record_id,
          });
          //为9，excel过来的这条报错了
          if (res.result && res.result == 9) {
            this.$message.error(`表格中剩余部分未保存成功，项目填写出错！`);
            this.is_all_true = false;
            is_success = false; //当前条是否保存成功
          }

          //如果保存的有错误，code还是为1，判断里面得字段
        } catch (e) {
          this.is_all_true = false;
          is_success = false; //当前条是否保存成功
        }
        if (!is_success) {
          //把接口保存失败的数据存在errData变量中
          this.errData.push(item);
        }
      }
      //如果上传过excel文件，那么要处理excel网页中还未加载的数据
      if (this.hasUploadExcel) {
        console.log("上传过excel文件，那么要处理excel网页中还未加载的数据");
        while (this.has_data) {
          await this.chuli_excelSheng();
          console.log(this.page, "shengyu----- page");
        }
      }
      //关闭菊花
      this.loading = false;
      if (this.is_all_true) {
        this.$message.success("保存成功！");
        this.$router.push({
          name: "yjCreate",
          query: {
            year: this.year,
            record_id: this.record_id,
          },
        });
      }
      //把错误的数据留在表格
      this.tableData = [...this.errData];
      this.errData = [];
    },
  },
};
</script>

<style lang="less" scoped>
.bodyControll {
  background: #ffffff;
  border-radius: 2px;
  padding: 20px 20px 40px;
  margin-top: 10px;

  .steps {
    border-bottom: 1px solid #dddddd;
    padding: 0 149px 24px;
  }

  .tableContrpll {
    margin-top: 28px;
  }

  /deep/ .el-table th {
    background: #f6f6f6 !important;
    color: #333;
    font-weight: 700 !important;
    font-size: 12px !important;
  }

  /deep/ .el-table tr {
    color: #333 !important;
    font-size: 12px;
  }

  /deep/ .el-table thead {
    background: #f6f6f6 !important;
    color: #333;
    font-weight: 700 !important;
    font-size: 12px !important;
  }

  /deep/ .el-table__cell {
    padding: 10px;
  }

  /deep/ .el-form-item {
    margin-bottom: unset !important;
  }

  .del {
    color: #f32323;
  }

  .them {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    font-size: 14px;
    font-weight: 700;
    color: #333333;
    padding-left: 15px;

    .line {
      width: 4px;
      height: 16px;
      background: #4379f6;
      left: 0px;
      position: absolute;
    }

    .bur {
      font-size: 12px;
      color: #333333;
    }

    .des {
      font-size: 14px;
      color: #666666;
      margin-left: 20px;
      font-weight: 400;
    }

    .textBox {
      display: flex;
      align-items: center;

      .gray {
        font-size: 12px;
        color: #666666;
        font-weight: 400;
      }

      .black {
        color: #333333;
        font-weight: 400;
      }
    }
  }

  .importBtn {
    margin-top: 28px;
    width: 100px;
    height: 32px;
    background: #4379f6;
    font-size: 12px;
    text-align: center;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .btnControll {
    display: flex;
    align-items: center;
    margin-top: 14px;

    .save {
      width: 100px;
      height: 38px;
      background: #f39020;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: #fff;
      margin-left: 20px;
      cursor: pointer;
    }

    .blue {
      background: #4379f6;
      margin-left: unset;
    }
  }
}

/deep/ .el-dialog__header {
  border-bottom: 1px solid #dddddd;
}

/deep/ .el-dialog__footer {
  background: #f5f5f5;
  height: 70px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 30px;
}

.tipNumber {
  font-size: 12px;
  color: #f32323;
}

.tex {
  margin-top: 5px;
  display: flex;
  align-items: center;

  .r {
    font-size: 12px;
    color: #666666;
  }

  .red {
    font-size: 12px;
    color: #f32323;
    margin-left: 10px;
  }
}

.upStyle {
  margin-top: 10px;
}

.linkExcel {
  font-size: 12px;
  color: #4379f6;
  cursor: pointer;
  text-decoration: underline;
}

.dialog-footer {
  /deep/ .el-button--primary {
    width: 100px;
    background: #f39020;
  }

  /deep/ .el-button {
    padding: unset;
    width: 100px;
    height: 32px;
    border-radius: unset;
  }
}
</style>
